import React from "react";
import { Modal, Form, Input, Button, message } from "antd";
import { MailOutlined } from "@ant-design/icons";

const { TextArea } = Input;

const ContactUsModal = ({
  contactUsVisible,
  setContactUsVisible,
  contactUsSubmit,
}) => {
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    contactUsSubmit(values);
    form.resetFields();
    setContactUsVisible(false);
  };

  return (
    <Modal
      title={
        <span>
          <MailOutlined style={{ marginRight: 8 }} />
          Contact Us
        </span>
      }
      visible={contactUsVisible}
      onCancel={() => setContactUsVisible(false)}
      footer={null}
      width={600}
    >
      <div style={{ marginBottom: 24, color: "#555" }}>
        <a
          href="https://wa.me/918082172443"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#25D366" }}
        >
          WhatsApp us
        </a>
        &nbsp;or call us at <a href="tel:+918082172443">8082172443</a> OR fill below form, we'll contact you.
      </div>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        style={{ marginTop: 24 }}
      >
        <Form.Item
          name="name"
          label="Full Name"
          rules={[{ required: true, message: "Please input your name!" }]}
        >
          <Input placeholder="Enter your full name" />
        </Form.Item>

        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: "Please input your email!" },
            { type: "email", message: "Please enter a valid email!" },
          ]}
        >
          <Input placeholder="Enter your email address" />
        </Form.Item>

        <Form.Item
          label="Mobile Number"
          name="mobileNumber"
          rules={[{ required: true }]}
        >
          <Input placeholder="Enter your mobile number" />
        </Form.Item>

        <Form.Item
          name="message"
          label="Message"
          rules={[{ required: true, message: "Please input your message!" }]}
        >
          <TextArea rows={6} placeholder="Type your message here..." />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
          <Button
            style={{ marginLeft: 8 }}
            onClick={() => setContactUsVisible(false)}
          >
            Cancel
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ContactUsModal;
